import { Pipe, PipeTransform } from '@angular/core';

/**
 * A date of birth as dd/MM/yyyy, read from the date part the API wrote. The API returns dates in
 * the server's time zone (Npgsql legacy timestamps), so converting through a Date and UTC would
 * show the day before on a server ahead of UTC.
 */
@Pipe({
  name: 'dob',
  standalone: true,
})
export class DobPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value ?? '');
    return match ? `${match[3]}/${match[2]}/${match[1]}` : '';
  }
}
